import React, { useMemo, useState, useCallback, useEffect } from "react";
import { Loader, Popover, Whisper, Tooltip, Badge, Icon as RsIcon } from "rsuite";
import { useLocation, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons"
import { mdiMicrosoftTeams } from "@mdi/js";
import Icon from "@mdi/react";
import styled, { css } from "styled-components";

import { renderMoney, fixedNumber, getManagedServices } from "utils";
import { commentTypes } from "const";
import {
    LS_ACCOUNTS_COLUMNS,
    LS_DIALERS_COLUMNS
} from "const/localStorageKeys";
import { api } from "api/loginRoutes";
import { TableClientSortHOC } from "components/Table/TableClientSort";
import TableClientSort from "components/Table/TableClientSort";


export default TableClientSortHOC(withRouter(({
    data = [],
    authInfo,
    loading,
    history,
    service,
    onSetRedirectTab,
    isMobile = false,
    ...props
}) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const searchServiceParam = searchParams.get("service");

    const [sortColumn, setSortColumn] = useState("name");
    const [sortType, setSortType] = useState("asc");
    const [sortLoading, setSortLoading] = useState(false);
    const [pickColumnsLoading, setPickColumnsLoading] = useState(false);
    // const [partialRedirect, setPartialRedirect] = useState(null);

    const getData = () => {
        // const limitedData = [data[0]];

        const formatedData = data.map(value => {
            const billing = value?.billing;
            const pendingAmount = billing?.pending_amount;
            const readyForPayment = billing?.ready_for_payment;
            const traffic = billing?.VOLUME_1_OUT ? billing.VOLUME_1_OUT : billing?.VOLUME_7_OUT ? billing.VOLUME_7_OUT : billing?.VOLUME_30_OUT;

            const allocatedNumbers = value.allocated_numbers || 0;
            const numbersWithTraffic = value.numbers_with_traffic || 0;
            const procentAllocated = allocatedNumbers !== 0 ? numbersWithTraffic / allocatedNumbers : 0;

            return {
                ...value,
                traffic: traffic,
                pending_amount: pendingAmount,
                ready_for_payment: readyForPayment,
                traffic_for_day: value?.billing?.VOLUME_1_OUT,
                traffic_for_week: value?.billing?.VOLUME_7_OUT,
                traffic_for_month: value?.billing?.VOLUME_30_OUT,
                created_at_date: new Date(value?.created_at),
                procent_with_traffic: procentAllocated
            }
        });


        if (sortColumn && sortType) {
            return formatedData.sort((a, b) => {
                let x = a[sortColumn];
                let y = b[sortColumn];

                if (typeof x === "string" && typeof y === "string") {
                    return sortType === "asc"
                        ? x.localeCompare(y)
                        : y.localeCompare(x);
                }

                return sortType === "asc" ? x - y : y - x;
            });
        }

        return formatedData;
    };

    const redirectToAccount = (id, idByService, searchServiceParam, partial = false, customTab = "general") => {
        const nextTab = partial ? customTab : "trunks";

        if (partial) {
            localStorage.setItem("ACCOUNT_ACTIVE_TAB", customTab);
        } else {
            localStorage.setItem("ACCOUNT_ACTIVE_TAB", "trunks");
        }

        const search = new URLSearchParams();

        if (searchServiceParam) {
            search.set("service", searchServiceParam);
        }

        search.set("tab", nextTab);

        const query = search.toString();
        const path = idByService
            ? `/accounts/view/${idByService}?${query}`
            : `/accounts/view/${id}?${query}`;

        window.open(path);
    };


    const columns = useMemo(() => {
        const hasBlockedAccount = data.find(item => {
            const { allocation_ban_expired_at = null } = item;
            return allocation_ban_expired_at !== null
        });

        const columns = [
            {
                label: "Account Name",
                minWidth: 250,
                flexGrow: 1,
                sortable: true,
                name: "Account Name",
                dataKey: "name",
                align: "left",
                value: ({ id, is_reliable: trusted, id_by_service, name, account_note_last }) => {
                    return <AccountNameContainer>
                        <AccountNotesIcon
                            type={account_note_last}
                            accountId={id}
                            redirectFunction={() => {
                                redirectToAccount(id, id_by_service, searchServiceParam, true, "notes");
                            }}
                        />
                        <AccountTrustedIcon
                            trusted={trusted}
                        />
                        <Whisper
                            trigger="hover"
                            speaker={<Tooltip><span>{name}</span></Tooltip>}
                        >
                            <div className="account_name">{name}</div>
                        </Whisper>
                    </AccountNameContainer>
                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "Account Nickname",
                flexGrow: 1,
                width: 150,
                minWidth: 150,
                sortable: true,
                name: "Account Nickname",
                dataKey: "nickname",
                align: "left",
                value: ({ nickname }) => <Whisper
                    trigger="hover"
                    speaker={<Tooltip><span>{nickname}</span></Tooltip>}
                >
                    <SmallText>{nickname}</SmallText>
                </Whisper>,
                pickable: true,
                isMobile: false,
            },
            {
                label: "Account Manager Name",
                flexGrow: 1,
                width: 170,
                minWidth: 170,
                sortable: true,
                name: "Account Manager Name",
                dataKey: "account_manager_name",
                align: "left",
                value: ({ account_manager_name }) => <Whisper
                    trigger="hover"
                    speaker={<Tooltip><span>{account_manager_name}</span></Tooltip>}
                >
                    <SmallText>{account_manager_name}</SmallText>
                </Whisper>,
                pickable: true,
                isMobile: false,
            },
            {
                label: "Service",
                // flexGrow: 1,
                width: 80,
                // width: 80,
                maxWidth: 120,
                sortable: true,
                name: "Service",
                dataKey: "service",
                align: "left",
                value: ({ service }) => {
                    return <ServiceCell service={service}>
                        {service}
                    </ServiceCell>
                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "Pending amount",
                flexGrow: 1,
                width: 125,
                minWidth: 125,
                sortable: true,
                align: "right",
                name: "Pending amount",
                dataKey: "pending_amount",
                value: ({ billing = {}, currency_name = "" }) => {
                    const balance = <>
                        {renderMoney(billing?.pending_amount, currency_name)}
                    </>;
                    return balance;

                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "Ready for payment",
                // flexGrow: 1,
                width: 140,
                minWidth: 140,
                sortable: true,
                align: "right",
                name: "Ready for payment",
                dataKey: "ready_for_payment",
                value: ({ billing = {}, currency_name = "" }) => {
                    const balance = <>
                        {renderMoney(billing?.ready_for_payment, currency_name)}
                    </>;
                    return balance;

                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "Day",
                // flexGrow: 1,
                width: 85,
                minWidth: 85,
                sortable: true,
                align: "right",
                name: "Day",
                dataKey: "traffic_for_day",
                value: ({ billing = {} }) => {
                    const traffic = <>{billing?.VOLUME_1_OUT}</>

                    return traffic;

                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "Week",
                // flexGrow: 1,
                width: 90,
                minWidth: 90,
                sortable: true,
                align: "right",
                name: "Week",
                dataKey: "traffic_for_week",
                value: ({ billing = {} }) => {
                    const traffic = <>{billing?.VOLUME_7_OUT}</>

                    return traffic;

                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "Month",
                // flexGrow: 1,
                width: 90,
                minWidth: 90,
                sortable: true,
                align: "right",
                name: "Month",
                dataKey: "traffic_for_month",
                value: ({ billing = {} }) => {
                    const traffic = <>{billing?.VOLUME_30_OUT}</>

                    return traffic;

                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "Numbers",
                // flexGrow: 1,
                width: 100,
                sortable: true,
                align: "right",
                dataKey: "allocated_numbers",
                name: "Allocated Numbers",
                value: ({ allocated_numbers = 0, numbers_with_traffic = 0 }) => {
                    const allocatedNumbers = <>{allocated_numbers || 0}/{numbers_with_traffic || 0}</>

                    return allocatedNumbers;
                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "% with traffic",
                // flexGrow: 1,
                width: 106,
                minWidth: 105,
                sortable: true,
                align: "right",
                dataKey: "procent_with_traffic",
                name: "% with traffic",
                value: ({ allocated_numbers = 0, numbers_with_traffic = 0, procent_with_traffic = 0 }) => {
                    const allocatedNumbers = allocated_numbers || 0;
                    const numbersWithTraffic = numbers_with_traffic || 0;

                    if (allocatedNumbers === 0) {
                        return "0%";
                    } else if (allocatedNumbers < numbersWithTraffic) {
                        return "100%";
                    }

                    if (procent_with_traffic === 0) {
                        return "0%";
                    }

                    return `${fixedNumber(procent_with_traffic * 100, 2, true, false)}%`;
                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "Creation date",
                // flexGrow: 1,
                // minWidth: 130,
                width: 130,
                sortable: true,
                align: "right",
                name: "Creation date",
                dataKey: "created_at_date",
                // formatData: "date",

                value: ({ created_at }) => {
                    const date = new Date(created_at);
                    const options = { year: "numeric", month: "long", day: "numeric" };
                    return <SmallText>{date.toLocaleDateString("en-US", options)}</SmallText>
                },
                pickable: true,
                isMobile: false,
            },
            {
                label: "Cntr",
                // flexGrow: 1,
                width: 60,
                minWidth: 60,
                sortable: true,
                name: "Country",
                dataKey: "cntr_code",
                pickable: true,
                isMobile: false,
            },
            {
                label: "",
                width: 75,
                sortable: false,
                dataKey: "contact",
                align: "left",
                name: "Contact info",
                value: ({ contact }) => {
                    return <ContactInfo
                        contact={contact}
                    />
                },
                pickable: false,
                isMobile: false,
            },
            {
                label: "",
                width: 40,
                sortable: false,
                align: "right",
                dataKey: "not_verified_users",
                name: "Not verified users",
                value: ({ id, id_by_service, not_verified_users }) => {
                    return <AccountNotVerifiedUsersIcon
                        redirectFunction={() => {
                            redirectToAccount(id, id_by_service, searchServiceParam, true);
                        }}
                        show={not_verified_users && not_verified_users !== 0}
                        count={not_verified_users}
                    />
                },
                pickable: false,
                isMobile: false,
            },
            ...(hasBlockedAccount ? [{
                label: "",
                dataKey: "allocation_ban_expired_at",
                width: 36,
                sortable: false,
                align: "right",
                name: "",
                value: ({ allocation_ban_expired_at = null }) => {
                    return <AccountBlockedNumberMinerIcon
                        show={allocation_ban_expired_at !== null}
                    />
                },
                fixed: "right",
                pickable: false,
                isMobile: false,
            }] : []),
            {
                label: "Account",
                flexGrow: 2,
                minWidth: 170,
                sortable: true,
                name: "Account",
                dataKey: "name",
                value: ({ id, id_by_service, name, nickname, account_note_last, account_manager_name }) => {
                    return <MobileAccountCell>
                        <MobileAccountNotes>
                            <AccountNotesIcon
                                type={account_note_last}
                                accountId={id}
                                redirectFunction={() => {
                                    redirectToAccount(id, id_by_service, searchServiceParam, true, "notes");
                                }}
                            />
                        </MobileAccountNotes>
                        <MobileAccountDetails>
                            <span title={name || ""}>Name:{name || "—"}</span>
                            <span title={nickname || ""}>Nickname: {nickname || "—"}</span>
                            <span title={account_manager_name || ""}>AM: {account_manager_name || "—"}</span>
                        </MobileAccountDetails>
                    </MobileAccountCell>
                },
                pickable: true,
                isMobile: true,
            },
            {
                label: "Balance",
                flexGrow: 1,
                minWidth: 100,
                sortable: true,
                name: "Balance",
                dataKey: "pending_amount",
                value: ({ billing = {}, currency_name = "" }) => (
                    <div className="table-two-staged__cell">
                        <div className="table-two-staged__cell-first">{renderMoney(billing?.pending_amount)}</div>
                        <div className="table-two-staged__cell-second">{renderMoney(billing?.ready_for_payment, currency_name)}</div>
                    </div>
                ),
                pickable: true,
                isMobile: true,
            },

            {
                label: "",
                width: 40,
                sortable: false,
                align: "right",
                dataKey: "not_verified_users",
                name: "Not verified users",
                value: ({ id, id_by_service, not_verified_users }) => {
                    return <AccountNotVerifiedUsersIcon
                        redirectFunction={() => {
                            redirectToAccount(id, id_by_service, searchServiceParam, true);
                        }}
                        show={not_verified_users && not_verified_users !== 0}
                        count={not_verified_users}
                    />
                },
                pickable: false,
                isMobile: true,
            },
            ...(hasBlockedAccount ? [{
                label: "",
                dataKey: "allocation_ban_expired_at",
                width: 36,
                sortable: false,
                align: "right",
                name: "",
                value: ({ allocation_ban_expired_at = null }) => {
                    return <AccountBlockedNumberMinerIcon
                        show={allocation_ban_expired_at !== null}
                    />
                },
                fixed: "right",
                pickable: false,
                isMobile: true,
            }] : []),
        ];

        return columns.filter(column => column.isMobile === isMobile);

    }, [data, service, isMobile]);

    const handleSortColumn = (sortColumn, sortType) => {
        setSortLoading(true);
        setTimeout(() => {
            setSortLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 300);
    };

    // const testData = getData();

    const columnSelectorName = useMemo(() => service ? LS_ACCOUNTS_COLUMNS : LS_DIALERS_COLUMNS, [service]);

    const pickableColumns = useMemo(() => {
        return columns;
    }, [columns]);

    return (
        <TableClientSort
            virtualized
            customHeight={700}
            data={getData()}
            loading={loading || sortLoading || pickColumnsLoading}
            rowHeight={!isMobile ? 30 : 50}
            rowClassName={(rowData) => {
                if (rowData) {
                    const { is_viewed, can_create_joined, id_by_service } = rowData;
                    let rowClassName = !rowData.active
                        ? "table-row-account__closed"
                        : "table-row-account table-row-account---link";
                    // let rowClassName = "table-row-account table-row-account---link";

                    if (!is_viewed || (!can_create_joined && !id_by_service)) {
                        rowClassName += " table-row-account--disabled";
                    }

                    return rowClassName;
                }
            }}
            onRowClick={({
                id, id_by_service, is_viewed, allocation_ban_expired_at = null,
                can_create_joined = false, ...acc
            }) => {
                const managedServiceList = getManagedServices(authInfo);

                if (can_create_joined && !id_by_service) {
                    redirectToAccount(id, null, searchServiceParam, true, "general");
                    const createJoinedAccounts = JSON.parse(localStorage.getItem("CREATE_JOINED_ACCOUNTS") || "[]");
                    createJoinedAccounts.push(String(id));
                    localStorage.setItem("CREATE_JOINED_ACCOUNTS", JSON.stringify(createJoinedAccounts));
                    return;
                }

                if (!can_create_joined && !id_by_service) {
                    return;
                }

                if (is_viewed) {
                    if (managedServiceList.length > 1) {
                        redirectToAccount(id, id_by_service, searchServiceParam);
                    } else {
                        redirectToAccount(id, null, searchServiceParam);
                    }
                }

            }}
            customRowClick
            {...props}
            sortColumn={sortColumn}
            sortType={sortType}
            onSortColumn={handleSortColumn}
            columns={columns}
            {...(!isMobile ? {
                columnSelectorLSKey: columnSelectorName,
                originalColumns: pickableColumns,
                onPickColumns: () => {
                    setPickColumnsLoading(true);
                    setTimeout(() => {
                        setPickColumnsLoading(false);
                    }, 300);
                }
            } : {})}
        />
    );
    {/* {columns.map(({dataKey, name, value = null, ...columnProps}) => (
                <Column {...columnProps}>
                    <HeaderCell>{name}</HeaderCell>
                    <Cell dataKey={dataKey}>{value}</Cell>
                </Column>
            ))}

            <Column key="table_scrollfix" width={0} fixed>
                <HeaderCell></HeaderCell>
                <Cell></Cell>
            </Column>

        </BaseTable> */}
}));

const AccountNotVerifiedUsersIcon = ({ show, count, redirectFunction }) => {

    return (
        <StyledAccountNotVerifiedUsersIcon
            style={{
                width: 20,
                marginRight: 10,
                display: "inline-block"
            }}
        >
            {show
                ? <Whisper
                    onClick={(e) => {
                        e.stopPropagation();
                        redirectFunction();
                    }}
                    placement="auto"
                    speaker={<Tooltip>Count of unconfirmed users: {count}</Tooltip>}
                >
                    <Badge
                        content={<span className="badge-count">{count}</span>}
                    >
                        <RsIcon
                            icon="envelope-o"
                            className="badge-icon"
                        />
                    </Badge>
                </Whisper>
                : null
            }
        </StyledAccountNotVerifiedUsersIcon>
    )
}

const AccountBlockedNumberMinerIcon = ({ show, count }) => {
    return (
        <StyledAccountBlockedNumberMinerIcon
            style={{
                width: 28,
                display: "inline-flex"
            }}
        >
            {show ? <Whisper
                placement="auto"
                speaker={<Tooltip>Blocked</Tooltip>}
            >
                <BlockedIconContent>
                    <FontAwesomeIcon icon={faBan} className="badge-icon" />
                    <span className="icon-letter">A</span>
                </BlockedIconContent>
            </Whisper>
                : null
            }
        </StyledAccountBlockedNumberMinerIcon>
    )
}

const AccountNotesIcon = ({
    type,
    accountId,
    redirectFunction
}) => {

    const [comments, setComments] = useState([]);
    const [timerId, setTimerId] = useState(null);


    useEffect(() => {
        setComments([]);
    }, [timerId]);


    const getNotes = useCallback(() => {
        const timerId = setTimeout(() => {
            api("account_note:get_short_list", {
                target: { account_id: accountId }
            })
                .then(res => {
                    if (res && res.account_note_list)
                        setComments(res.account_note_list);
                })
        }, 500);
        setTimerId(timerId);
    }, [accountId]);


    const clearNotes = useCallback(() => {
        clearTimeout(timerId);
    }, [timerId]);


    return (
        <span style={{ width: 20, minWidth: 20, display: "inline" }}>
            {type || type === 0
                ? <Whisper
                    onClick={(e) => {
                        e.stopPropagation();
                        redirectFunction();
                    }}
                    enterable={comments.length}
                    placement="auto"
                    speaker={
                        <Popover
                            title={"Recent notes"}
                        // MOUSE
                        >
                            <div>
                                {comments && comments.length
                                    ? comments.map(item => (
                                        <div style={{ textAlign: "left" }}>
                                            <span
                                                className={"rs-icon rs-icon-" + commentTypes[item.type].icon}
                                                style={{
                                                    width: 20,
                                                    color: commentTypes[item.type].color,
                                                }}
                                            />
                                            &nbsp;{item.text}
                                        </div>
                                    ))
                                    : <Loader content="Loading..." style={{ paddingTop: 6 }} size="xs" />
                                }
                            </div>
                        </Popover>
                    }
                >
                    <span
                        onMouseEnter={getNotes}
                        onMouseOut={clearNotes}
                        className={"rs-icon rs-icon-" + commentTypes[type].icon}
                        style={{ color: commentTypes[type].color }}
                    />
                </Whisper>
                : null
            }
        </span>
    )
};

const AccountTrustedIcon = ({
    trusted,
    icon = "check-circle"
}) => {
    return (
        <span style={{ width: 20, minWidth: 20, display: "inline" }}>
            {trusted ? <Whisper
                enterable={trusted}
                placement="auto"
                speaker={<Tooltip>This account is trusted</Tooltip>}
            >
                <span
                    className={"rs-icon rs-icon-" + icon}
                    style={{ color: "dodgerblue", fontSize: 13 }}
                />
            </Whisper> : null}
        </span>
    );
};

const ContactInfo = ({ contact }) => {
    if (!contact) {
        return <></>;
    }

    const tgUsername = contact.telegram_username;
    const clearTgUsername = tgUsername && tgUsername.startsWith("@") ? tgUsername.slice(1) : tgUsername;
    const telegramUrl = `tg://resolve?domain=${clearTgUsername}`;
    const teamsUrl = contact.teams_link;
    const openTelegram = (e) => {
        e.stopPropagation();
        window.open(telegramUrl, "_self");
    };

    const openTeams = (e) => {
        e.stopPropagation();
        window.open(teamsUrl, "_self");
    };

    return <ContactIcons>
        {contact.telegram_username ? <span onClick={openTelegram}>
            <Whisper
                speaker={<Tooltip>Click to open a chat in Telegram</Tooltip>}
                placement="bottomEnd"
            >
                <RsIcon className={`telegram ${contact.telegram_id_ready ? "active" : ""}`} icon="telegram" />
            </Whisper>
        </span> : <></>}
        {contact.teams_link ? <span onClick={openTeams}>
            <Whisper
                speaker={<Tooltip>Click to open a chat in Teams</Tooltip>}
                placement="bottomEnd"
            >
                <MdiIcon path={mdiMicrosoftTeams} size={1} />
            </Whisper>
        </span> : <></>}
        {contact.phone ? <Whisper
            speaker={<Tooltip>{contact.phone}</Tooltip>}
            placement="bottomEnd"
        >
            <RsIcon className="phone" icon="phone" />
        </Whisper> : <></>}
    </ContactIcons>;
};

const StyledAccountBlockedNumberMinerIcon = styled.span`
    && {
        color: red;
        align-items: center;
        justify-content: center;
    }
    && .badge-icon {
        font-size: 17px;
        font-weight: 300;
    }
    && .icon-letter {
        position: absolute;
        top: 3px;
        left:4px;
        font-size: 15px;
        line-height: 1em;
        font-weight: 500;
    }
`;

const BlockedIconContent = styled.span`
    position: relative;
    display: inline-flex;
    width: 28px;
    height: 20px;
    align-items: center;
`;

const MobileAccountCell = styled.div`
    display: flex;
    width: 100%;
    min-width: 0;
    height: 100%;
    align-items: center;
`;

const MobileAccountNotes = styled.span`
    display: inline-flex;
    flex: 0 0 16px;
    width: 16px;
    margin-right: 3px;
    align-items: center;
    justify-content: flex-start;

    > span {
        display: inline-flex !important;
        width: 14px !important;
        min-width: 14px !important;
    }
`;

const MobileAccountDetails = styled.span`
    display: flex;
    min-width: 0;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: center;

    > span {
        display: block;
        overflow: hidden;
        font-size: 11px;
        line-height: 13px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

const ServiceCell = styled.span`
    ${props => props.service === "voice" ? css`
        color: var(--color-violet);
    ` : css`
        color: var(--color-info);
    `
    }
`;


const AccountNameContainer = styled.div`
    display: flex;
    justify-content: flex-start;

    .account_name {
        margin-left: 5px;
    }
`;

const StyledAccountNotVerifiedUsersIcon = styled.span`
    .rs-badge {
    
        padding: 2px;
        font-size: 9px;
        
        .rs-badge-content {
            box-shadow: 0 0 0 1px #ffffff;
            background-color: var(--color-info);
            border-radius: 11px;
            font-size: 10px !important;
            line-height: 11px;
            padding: 0 2px;
            color: #ffffff;
            margin-right: 1px;
            margin-top: 3px;
            height: 11px;
            min-width: 11px;
            text-align: center;
        }
        
        .badge-count {
            font-weight: 700;
            font-size: 9px;
        }
    }
`;

const ContactIcons = styled.span`
    && {
        display: flex;
        align-items: center;
    }

    && .rs-icon {
        font-size: 16px;
        margin-right: 2px;
    }

    && .rs-icon.telegram {
        font-size: 14px;
        color: gray;
    }

    && .rs-icon.telegram.active {
        color: #24A1DE;
    }

    && .rs-icon.phone {
        color: #13d161;
        margin-bottom: 1px;
    }
`;

const SmallText = styled.span`
    && {
        font-size: 12px;
    }
`;

const MdiIcon = styled(Icon)`
    && {
        width: 1.1rem !important;
        height: 1.1rem !important;
        color: #5159C8 !important;
        margin-top: -3px;
    }
`;
